import {cancel, fork, put, select, take} from 'redux-saga/effects';
import {rsf} from '../globals/firebase';
// import {IUserOrGroup} from '../Interfaces/Users.inteface'
import * as paths from '../Providers/paths';
import * as rootSelectors from '../selectors/root';
import * as userRoutines from './routines/userRoutines';

export function* resetUserInfoSync() {
    yield put(userRoutines.stopSyncingUserInfo.trigger());
    yield put(userRoutines.syncUserInfo());
}


export function* syncUserInfoSaga() {
    //Synces active users from FB
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'userInfo'), {
        successActionCreator: userRoutines.syncUserInfo.success,
        failureActionCreator: userRoutines.syncUserInfo.failure,
    });
}


export default function* rootUserInfoWatcher() {

    while (yield take(userRoutines.stopSyncingUserInfo.TRIGGER)) {
        const bgUserInfoSync = yield fork(syncUserInfoSaga);
        yield take(userRoutines.stopSyncingUserInfo.TRIGGER);
        yield cancel(bgUserInfoSync);
    }
}
